import React from "react";
import "./ActivityDescription.css";
import { Calendar } from "../Calendar/Calendar";
import { Button } from "../../Components/Button/Button";
import { ActivityList } from "../ActivityList/ActivityList";
import { Separator } from "../../Components/Separator/Separator";

export const ActivityDescription = ({
  activity,
  activities,
  onActivityClick,
}) => {
  const sendToWhatsAppp = () => {
    window.open(
      `https://wa.me/529541686583?text=${activity.whatsappMessage}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <div
        className="activity-description__left"
        style={{ color: activity.fontColor }}
      >
        <h1 className="activity-description__title">{activity.title}</h1>
        <p className="activity-description__location">{activity.location}</p>
        <Separator color={activity.fontColor} />
        <h2 className="activity-description__overview__title">Descripción</h2>
        <p className="activity-description__overview">{activity.overview}</p>
        <p className="activity-description__cost">
          {activity.cost}{" "}
          <span className="activity-description__cost__text">
            {activity.costDescription}
          </span>
        </p>
        <Button text={activity.buttonText} onClick={() => sendToWhatsAppp()} />
        <p className="activity-description__disclaimer">
          * Los precios son por persona.
          <br />
          * Todas las reservaciones se hacen a traves de WhatsApp.
          <br />* Todas las reservaciones requieren un anticipo del 20% de la
          totalidad del costo.
        </p>
      </div>
      <div className="activity-description__right">
        <div className="activity-details__wrapper">
          {/* <Calendar source={activity.calendarSource} /> */}
          {activity.details ? (
            <div className="activity-details__long">{activity.details}</div>
          ) : null}
        </div>
        <ActivityList
          activities={activities}
          selectedActivity={activity}
          onListActivityClick={onActivityClick}
        />
      </div>
    </>
  );
};
